import { restHelper } from '../helpers/rest.helper';

const Get = async () => {
    let response = await restHelper.post('api/UserProfile/Get', null);
    return response;
}

export default {
    Get
}